import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, Plus } from 'lucide-react';
import { PricingSelector } from './PricingSelector';
export function FooterFAQ() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const faqs = [{
    q: '¿Cómo recibo el Megapack después de comprar?',
    a: 'Una vez procesado el pago a través de Mercado Pago, serás redirigido inmediatamente a la página de descarga y también recibirás un mail con el link de acceso a todos los archivos PDF.'
  }, {
    q: '¿Sirve si recién empecé a entrenar o soy voluntario sin formación?',
    a: 'Absolutamente. El sistema está diseñado paso a paso. No damos nada por sentado. Te va a ahorrar años de prueba y error.'
  }, {
    q: '¿Funciona para todas las categorías o solo para algunas?',
    a: 'Cubre desde Baby Básquet (5 años) hasta Juveniles (17 años), con planificaciones, objetivos y ejercicios específicos para cada etapa de desarrollo.'
  }, {
    q: '¿Los 6 bonos están incluidos en las dos ofertas?',
    a: 'Sí, tanto el Megapack estándar como el PRO incluyen los 6 bonos estratégicos gratuitos.'
  }, {
    q: '¿Es solo para lectura o las planillas se pueden imprimir?',
    a: 'Todos los materiales están en formato PDF de alta calidad, listos para imprimir. De hecho, recomendamos imprimir las planillas de práctica y scouting para llevar a la cancha.'
  }, {
    q: '¿Qué diferencia tiene con contenido gratuito de YouTube?',
    a: 'En YouTube hay ejercicios sueltos. Esto es un SISTEMA completo y progresivo. No perdés tiempo buscando, tenés todo ordenado y sabés exactamente qué hacer cada día del año.'
  }, {
    q: '¿Por qué elegir el PRO y no el estándar?',
    a: 'El PRO incluye el sistema de juego (táctica avanzada) y el método de desarrollo de talento. Es para el entrenador que no solo quiere organizar sus prácticas, sino que quiere ganar partidos y formar jugadores de élite.'
  }, {
    q: '¿La garantía es real?',
    a: '100% real. Tenés 7 días para revisar el material. Si sentís que no te sirve, nos mandás un mail y te devolvemos el dinero sin hacerte preguntas.'
  }];
  return <>
      {/* Guarantee Section */}
      <section className="bg-brand-orange py-10 md:py-20 relative overflow-hidden" data-id="element-8">
        <div className="absolute inset-0 bg-court-pattern opacity-10" data-id="element-9"></div>
        <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-10">
          <motion.div initial={{
          scale: 0.6,
          opacity: 0,
          rotate: -10
        }} whileInView={{
          scale: 1,
          opacity: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 120
        }} className="inline-flex items-center justify-center w-16 h-16 md:w-24 md:h-24 bg-white rounded-full mb-4 md:mb-8 shadow-2xl" data-id="element-11">
            <ShieldCheck size={32} className="text-brand-orange md:w-12 md:h-12" data-id="element-12" />
          </motion.div>
          <h2 className="font-display text-3xl md:text-6xl text-white mb-3 md:mb-6 leading-none" data-id="element-13">
            GARANTÍA TOTAL
            <br data-id="element-14" />7 DÍAS
          </h2>
          <p className="text-white/90 text-sm md:text-xl font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-15">
            Descargás los tomos, los probás en tu cancha. Si no es lo que
            esperabas: sin preguntas, sin formularios, sin drama. Te devolvemos
            el 100% de lo que pagaste.
            <span className="opacity-75 text-xs md:text-sm block mt-2" data-id="element-16">
              (Tasa de devoluciones &lt; 1%)
            </span>
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-brand-cream py-12 md:py-24 border-b border-gray-200" data-id="element-17">
        <div className="max-w-3xl mx-auto px-4" data-id="element-18">
          <div className="text-center mb-6 md:mb-16" data-id="element-19">
            <h3 className="text-brand-orange font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-20">
              Dudas Comunes
            </h3>
            <h2 className="font-display text-3xl md:text-5xl text-brand-dark" data-id="element-21">
              PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-2 md:space-y-3" data-id="element-22">
            {faqs.map((faq, i) => {
            const isOpen = openFaq === i;
            return <motion.div key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.03
            }} className={`bg-white border rounded-xl overflow-hidden shadow-sm transition-colors ${isOpen ? 'border-brand-orange' : 'border-gray-200'}`} data-id="element-23">
                  <button onClick={() => setOpenFaq(isOpen ? null : i)} className="w-full flex items-center justify-between p-4 md:p-5 text-left focus:outline-none active:bg-gray-50" data-id="element-24">
                    <span className="font-bold text-brand-dark text-sm md:text-base pr-4 leading-snug" data-id="element-25">
                      {faq.q}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} className={`shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-orange text-white' : 'bg-gray-100 text-brand-orange'}`} data-id="element-26">
                      <Plus size={16} data-id="element-27" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-28">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25
                }} className="overflow-hidden" data-id="element-29">
                        <div className="px-4 md:px-5 pb-4 md:pb-5 text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-30">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-brand-dark py-10 md:py-20 relative overflow-hidden" data-id="element-31">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-32"></div>
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-33">
          <h2 className="font-display text-2xl md:text-5xl text-white mb-3 md:mb-4 leading-tight" data-id="element-34">
            NO DEJES PASAR ESTA OPORTUNIDAD
          </h2>
          <p className="text-gray-400 text-xs md:text-base mb-6 md:mb-8 font-medium" data-id="element-35">
            Elegí tu pack y empezá hoy mismo
          </p>

          <div className="bg-gray-900/60 backdrop-blur-sm border border-gray-800 rounded-2xl p-4 md:p-8" data-id="element-36">
            <PricingSelector variant="compact" data-id="element-37" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#050505] py-8 md:py-12 border-t border-gray-900" data-id="element-38">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-39">
          <div className="font-display text-xl md:text-2xl text-white mb-3 md:mb-4" data-id="element-40">
            🏀 MEGAPACK BÁSQUET{' '}
            <span className="text-brand-orange" data-id="element-41">RESUELTO™</span>
          </div>
          <p className="text-gray-500 text-xs md:text-sm max-w-md mx-auto mb-6 md:mb-8 leading-relaxed" data-id="element-42">
            El sistema N°1 para entrenadores de básquet juvenil en Argentina.
            Porque formar pibes no debería costarte el doble de estrés que el
            partido.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-gray-400 text-xs md:text-sm mb-6 md:mb-8" data-id="element-43">
            <a href="#" className="hover:text-brand-orange transition-colors break-all" data-id="element-44">
              contacto@abastecedordigital.shop
            </a>
            <span className="hidden md:block" data-id="element-45">•</span>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-46">
              @abastecedordigital.shop
            </a>
            <span className="hidden md:block" data-id="element-47">•</span>
            <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-48">
              abastecedordigital.shop
            </a>
          </div>

          <div className="text-gray-600 text-[10px] md:text-xs" data-id="element-49">
            © abastecedordigital.shop™ 2026 — Todos los derechos reservados
          </div>
        </div>
      </footer>
    </>;
}